import React from 'react';
import CarveOutGrid from '../../grids/contractGrids/CarveOutGrid';

const CarveOutTab: React.FC = () => {
  return <CarveOutGrid />;
};

export default CarveOutTab;